import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { useLayout, usePageData } from '../../core'
import { DefaultTitleWithBreadcrumbs } from '../header/page-title/DefaultTitle'
import { Link } from 'react-router-dom'

interface Props {
  rightSection?: ReactNode
  extraClass?: string
  customPadding?: string
  showSummaryCard?: boolean
}

const ManageProjectStageToolbar: React.FC<Props> = ({
  rightSection,
  extraClass,
  customPadding = 'py-8',
  showSummaryCard = true,
}) => {
  const { classes, config } = useLayout()
  const { pageBreadcrumbs } = usePageData()

  return (
    <>
      <div id='kt_breadcrumb_container' className='mb-2 mt-3'>
        <div className='container'>
          {pageBreadcrumbs && pageBreadcrumbs?.length > 0 &&
            config.pageTitle?.breadCrumbs && (
              <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1'>
                {pageBreadcrumbs.map((item, index) => (
                  <li
                    className='breadcrumb-item text-gray-800 opacity-75'
                    key={item.path || item.title || index}
                  >
                    {!item.isSeparator ? (
                      item.path ? (
                        <Link
                          className='text-gray-800 text-hover-primary'
                          to={item.path}
                          state={item.state}
                        >
                          {item.icon || item.title}
                        </Link>
                      ) : (
                        <span className='text-gray-800'>{item.title}</span>
                      )
                    ) : (
                      <i className='fa fa-chevron-right text-gray-800'></i>
                    )}
                  </li>
                ))}
              </ul>
            )}
        </div>
      </div>

      {showSummaryCard && (
        <div className={`toolbar ${customPadding}`} id='kt_toolbar'>
          <div
            id='kt_toolbar_container'
            className={clsx(classes.toolbarContainer.join(' '), extraClass)}
          >
            <div className='card w-100'>
              <div className='card-body p-2 d-flex flex-stack gap-8'>
                <DefaultTitleWithBreadcrumbs />

                {rightSection && (
                  <div className='text-gray-800 fs-3'>
                    {rightSection}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export { ManageProjectStageToolbar }